const COUPON_LIST_PAGE = {
  title: 'Lista de Cupons',
  noCouponsFound: 'Nenhum cupom encontrado',
  noPermission: 'Você não tem permissão para acessar esta página',
  active: 'Ativo',
  inactive: 'Inativo',
  noData: 'n/a',
  forDiscount: 'de desconto',
  unlimited: 'Ilimitado',
  detailsModal: {
    status: 'Status:',
    type: 'Tipo:',
    minimumSubtotal: 'A partir de:',
    maximumSubtotal: 'Desconto de até:',
    startsAt: 'Início:',
    endsAt: 'Fim:',
    usageLimit: 'Limite de usos:',
    history: 'Histórico',
    createdAt: 'Data de criação:',
    createdBy: 'Criado por:',
    updatedAt: 'Última modificação:',
    updatedBy: 'Modificado por:',
    description: 'Descrição',
  },
  couponCard: {
    status: 'Status:',
    type: 'Tipo:',
    usageLimit: 'Limite de usos:',
    createdBy: 'Criado por:',
    startsAt: 'Início:',
    endsAt: 'Fim:',
    edit: 'Editar',
    moreInformation: 'Mais informações',
  },
  searchCoupon: {
    placeholder: 'Digite o código do cupom',
    search: 'Buscar',
    newCoupon: 'Criar novo cupom',
  },
}

export default COUPON_LIST_PAGE
